import axios from 'axios';

import { DOCCHAT_ROOT_URL } from '../config';

export const axiosDocChatInstance = axios.create({
  baseURL: DOCCHAT_ROOT_URL,
});
